import {SearchableItemService} from "../../../services/SearchableItemService";
import {textFilterParamsValues} from "../reactTableController";

export const defaultSortModel = [
    {
        colId: 'accountNumber',
        sort: 'asc',
        sortIndex: 0
    },
    {
        colId: 'errorTime',
        sort: 'asc',
        sortIndex: 1
    }
];
export const erroneousStatementsCols = function (translate, userService) {
    const filterFormatter = userService.filterFormatter;
    return [{
        field: "shortName",
        headerName: translate.instant('ACCOUNT_NAME'),
        sortable: true,
        filter: 'agTextColumnFilter',
        filterParams: textFilterParamsValues
    }, {
        field: "accountNumber",
        headerName: translate.instant('ACCOUNT_NUMBER'),
        sortable: true,
        filter: 'agTextColumnFilter',
        filterParams: textFilterParamsValues
    }, {
        field: "userDefinedAlias1",
        headerName: translate.instant('ACCOUNT_ALIAS'),
        sortable: true,
        filter: 'agTextColumnFilter',
        filterParams: textFilterParamsValues
    }, {
        field: "bic",
        headerName: translate.instant('BIC'),
        sortable: true,
        filter: "agSetColumnFilter",
        filterParams: { values: params => {// fetch values from server
                new SearchableItemService(userService).readKindItems(['bic'])
                    .then(data => params.success(data.map(it => it.code)));
            }}
    }, {
        field: "errorTime",
        headerName: translate.instant('ERROR_TIME'),
        sortable: true,
        filter: 'agDateColumnFilter',
        filterParams: {filterOptions: ['equals', 'inRange'], suppressAndOrCondition: true},
        valueGetter: (params) => {
            return params.data ?
                filterFormatter('fsDateTimeNoLocal')( params.data.errorTime) : "";
        }
    }, {
        field: "errorText",
        headerName: translate.instant('ERROR_MESSAGE'),
        sortable: true,
        filter: 'agTextColumnFilter',
        filterParams: textFilterParamsValues
    }];
}
